import { defineComponent, ref, computed } from "vue";

export default defineComponent({
  name: "c-soon",

  props: {
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
  },

  setup(props) {
    const className = ref(props.class);
    const styleName = ref(props.style);

    const isLoading = computed(() => {
      return props.loading;
    });

    return {
      className,
      styleName,
      isLoading,
    };
  },
});
